/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_create_drawer_button_loading = /** @type {(inputs: {}) => string} */ () => {
	return `Creando tarjeta virtual...`
};

const en_cards_create_drawer_button_loading = /** @type {(inputs: {}) => string} */ () => {
	return `Creating virtual card...`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_create_drawer_button_loading = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_create_drawer_button_loading(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_create_drawer_button_loading", locale)
	if (locale === "es") return es_cards_create_drawer_button_loading(inputs)
	return en_cards_create_drawer_button_loading(inputs)
};
export { cards_create_drawer_button_loading as "cards.create_drawer.button_loading" }